<template>
<div class="flex flex-col h-screen">
  <div class="flex items-center justify-start bg-beige-academy-300 w-full py-2
  text-white text-left mt-16">
    <div class="text-base w-full px-6 md:px-8 font-sans-serif flex">
      <router-link class="pr-1" to="/teachers">
        {{$t('teacher.all')}}
      </router-link>
    </div>
  </div>
  <div class="flex flex-col top-0 mx-auto w-full h-auto">
    <div class="flex py-3 md:py-10 w-full justify-around items-center
      blur z-10 px-3 lg:px-20">
      <div class="flex items-center">
        <img :src="urlPhoto" alt="foto profilo" id="photo"
            class="rounded-full w-20 md:w-28 transform group-hover:scale-105
            group-hover:border-chocolate-academy-600">
        <div class="flex flex-col justify-start ml-6 lg:ml-16">
          <div class="flex justify-between">
            <h1 class="font-bold text-background-academy text-lg md:text-2xl lg:text-3xl uppercase
            transform group-hover:scale-105 w-full flex items-center"
            id="title">{{teacher.name}}</h1>
          </div>
          <h2 class="flex pt-2">
            <div class="text-md text-grey-academy-300 opacity-75 pr-2 flex
              justify-start">
              {{ teacher.title }}
            </div>
            <div class="flex flex-col md:hidden font-sans-serif" v-if="teacher.user">
              <button class="flex items-center" v-if="teacher.user.facebook">
                <img src="@/images/facebook.svg" class="w-5 mr-4">
                <span>Facebook Link</span>
              </button>
              <button class="flex items-center mt-4" v-if="teacher.user.instagram">
                <img src="@/images/instagram.svg" class="w-5 mr-4">
                <span>Instagram Link</span>
              </button>
            </div>
            <stars-rate :starsAvg="teacher.stars_avg" class="justify-start"
              starsClass="w-5 pl-1 hidden lg:block" />
          </h2>
          <teacher-statistics></teacher-statistics>
        </div>
      </div>
      <button class="bg-beige-academy-500 rounded-3xl px-3 lg:px-5 h-10 lg:h-16"
        @click="contact(user, teacher.user)" v-if="authenticated">
          <message-icon class="w-4 lg:w-7 text-white" />
      </button>
      <div class=" flex-col hidden md:flex font-sans-serif" v-if="teacher.user">
        <button class="flex items-center" v-if="teacher.user.facebook">
          <img src="@/images/facebook.svg" class="w-8 mr-4">
          <span>Facebook Link</span>
        </button>
        <button class="flex items-center mt-4" v-if="teacher.user.instagram">
          <img src="@/images/instagram.svg" class="w-8 mr-4">
          <span>Instagram Link</span>
        </button>
      </div>
    </div>
    <div class="flex bg-white h-screen z-10">
      <nav class="flex flex-col flex-wrap sticky inset-y-0 top-0 justify-start h-screen">
        <router-link class="shadow mr-1 w-20 h-20 lg:w-28 lg:h-28 flex
          flex-col justify-center items-center
          hover:bg-beige-academy-500 hover:text-white bg-white"
          :to="pathDashboard"
          :class="$route.fullPath === pathDashboard ?
          'bg-beige-academy-500 text-white' : 'text-black'">
            <profile-icon/>
            <span class="text-xs lg:text-base pt-2 font-sans-serif">{{ $t('teacher.info') }}</span>
        </router-link>
        <router-link class="mr-1 shadow w-20 h-20 flex flex-col justify-center
          items-center hover:bg-beige-academy-500 hover:text-white bg-white lg:w-28 lg:h-28"
        :to="pathDashboard+'/calendar'" v-if="authenticated"
          :class="$route.fullPath === pathDashboard+'/calendar' ?
          'bg-beige-academy-500 text-white' : 'text-black'">
            <calendar-icon />
            <span class="text-xs lg:text-base pt-2 font-sans-serif">
              {{ $t('teacher.calendar') }}</span>
        </router-link>
        <router-link class="mr-1 shadow w-20 h-20 flex flex-col justify-center
          items-center hover:bg-beige-academy-500 hover:text-white bg-white lg:w-28 lg:h-28"
          :to="pathDashboard+'/lessons'"
          :class="$route.fullPath === pathDashboard+'/lessons' ?
          'bg-beige-academy-500 text-white' : 'text-black'">
            <classroom-icon />
            <span class="text-xs lg:text-base pt-2 font-sans-serif">
              {{ $t('teacher.tiers') }}</span>
        </router-link>
        <router-link class="mr-1 shadow w-20  h-20 flex-col justify-center
          items-center hover:bg-beige-academy-500 hover:text-white bg-white lg:w-28 lg:h-28
          hidden md:flex"
          :to="pathDashboard+'/masterclasses'"
          :class="$route.fullPath === pathDashboard+'/masterclasses' ?
          'bg-beige-academy-500 text-white' : 'text-black'">
            <masterclass-icon />
            <span class="text-xs lg:text-base pt-2 font-sans-serif">
              {{ $t('teacher.masterclasses') }}</span>
        </router-link>
        <router-link class="mr-1 shadow w-20 h-20 flex flex-col justify-center
            items-center hover:bg-beige-academy-500 hover:text-white bg-white lg:w-28 lg:h-28"
          :to="pathDashboard+'/reviews'"
            :class="$route.fullPath === pathDashboard+'/reviews' ?
            'bg-beige-academy-500 text-white' : 'text-black'">
              <reviews-icon class="w-7 lg:w-10" />
              <span class="text-xs lg:text-base pt-1 font-sans-serif">
                {{ $t('teacher.review') }}</span>
          </router-link>
      </nav>

      <section class="flex w-screen h-screen">
          <router-view></router-view>
      </section>

      <modal resizable name="messageFormModal" />
      <v-dialog name="inviato" />
    </div>
  </div>
</div>
</template>

<script>
// import TeacherRates from '@/components/teachers/TeacherRates.vue';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import { mapGetters } from 'vuex';
import { getTeacherBySlug } from '@/services/TeacherService';
// import SoundWave from '@/components/graphics/SoundWave.vue';
import MessageIcon from '../components/graphics/MessageIcon.vue';
import CalendarIcon from '../components/graphics/CalendarIcon.vue';
import ClassroomIcon from '../components/graphics/ClassroomIcon.vue';
import MasterclassIcon from '../components/graphics/MasterclassIcon.vue';
import StarsRate from '../components/graphics/StarsRate.vue';
import ReviewsIcon from '../components/graphics/ReviewsIcon.vue';
import ProfileIcon from '../components/graphics/ProfileIcon.vue';
import TeacherStatistics from '../components/teachers/TeacherStatistics.vue';
// import RoundPhotoAndName from '../components/graphics/RoundPhotoAndName.vue';
// import DashboardHeading from '../components/graphics/DashboardHeading.vue';

export default {
  data() {
    return {
      teacher: {},
      teacherTimezone: '',
    };
  },

  components: {
    MessageIcon,
    CalendarIcon,
    ClassroomIcon,
    MasterclassIcon,
    StarsRate,
    ReviewsIcon,
    ProfileIcon,
    TeacherStatistics,
  },

  mixins: [StreamFunctionsMixin],

  computed: {
    urlPhoto() {
      return this.teacher.urlProfilePhoto ? this.teacher.urlProfilePhoto : 'https://baroon.fra1.digitaloceanspaces.com/dev/academy/users/UserIcon.png';
    },

    ...mapGetters({
      user: 'auth/user',
      authenticated: 'auth/authenticated',
      choosenTimezone: 'timezone/choosenTimezone',
    }),

    pathDashboard() {
      return `/teachers/${this.teacher.slug}`;
    },
  },

  created() {
    this.getSelectedTeacher();
  },

  methods: {
    getSelectedTeacher() {
      getTeacherBySlug(this.$route.params.slug).then((response) => {
        this.teacher = response.data;
        this.teacherTimezone = this.teacher.user.timezone;
        if (this.authenticated && this.user.id === this.teacher.user.id) {
          this.goToDashboard();
        }
      }).catch(() => {
        console.log('Lettura teacher selezionato fallita');
      });
    },

  },

};
</script>

<style lang="scss" scoped>
  .shadow {
    --tw-shadow: 0 4px 6px -1px rgb(166, 145, 133), 0 2px 4px -1px rgb(166, 145, 133);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #A69185), var(--tw-ring-shadow, 0 0 #A69185),
    var(--tw-shadow);
  }
  .blur {
    background: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur( 3px );
    -webkit-backdrop-filter: blur( 1px );
    --tw-shadow: 0 4px 6px -1px rgb(179, 177, 177), 0 2px 4px -1px rgb(143, 133, 133);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),
      var(--tw-shadow);
  }

  .top-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 320px;
  height: 60px;
}

.search {
  position: absolute;
  top: 155px;
  left: 20px;
  right: 20px;
  input {
    width: 265px;
    transition: width 0.2s;
    -webkit-appearance: none;
  }
}

.top {
  height: 250px;
  padding-top: 40px;
  position: relative;
}

</style>
